<bb-content-back-drop></bb-content-back-drop>
<h1>Balikbayad is part of First Digital Finance Corp</h1>
<section [ngClass.xs]="'mobile'" fxLayout="column" fxLayoutGap="16px">
  <img alt="About Us" bbResponsiveSrc="/assets/about-us.jpg"/>
  <div fxFlex.gt-xs="16px"></div>
  <article fxLayout.xs="column" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2 fxFlex="30">
      Our Company
    </h2>
    <div>
      First Digital Finance Corporation doing business under the names and styles of
      FDFC, Balikbayad, and Billease (SEC Registration No.: CS201516347;
      Certificate of Authority to operate as a financing company No.: 1101)
      <br>
      Address: 9F, TM Kalaw Center, 667 TM Kalaw Ave, Ermita, Manila
    </div>
  </article>
  <article fxLayout.xs="column" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2 fxFlex="30">
      Our founders
    </h2>
    <div>
      We are a team of experienced professionals with both local and international experience in banking,
      consulting and technology.
    </div>
  </article>
  <article fxLayout.xs="column" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2 fxFlex="30">
      Our mission
    </h2>
    <div>
      To drive financial innovation throughout the region. Our products leverage the most up to date
      technology to
      minimize operational cost and improve efficiency.
    </div>
  </article>
</section>
